import React from 'react';
import cn from 'classnames';

export interface NumberedRowListProps {
  items: React.ReactNode[];
  variant?: 'default' | 'inverse';
  className?: string;
}

const variantTokens = {
  default: {
    row: 'bg-ds-bg-surface-soft-4',
    number: 'text-ds-text-1',
    label: 'text-ds-text-1',
  },
  inverse: {
    row: 'bg-ds-bg-surface-1/20',
    number: 'text-ds-text-inverse-1',
    label: 'text-ds-text-inverse-1',
  },
};

export const NumberedRowList: React.FC<NumberedRowListProps> = ({
  items,
  variant = 'default',
  className,
}) => {
  const tokens = variantTokens[variant];

  return (
    <ul className={cn('flex flex-col gap-1.5', className)}>
      {items.map((item, i) => (
        <li
          key={i}
          className={cn('flex items-start gap-2 rounded-ds-2 py-2 px-3 list-none', tokens.row)}
        >
          <span className={cn('text-ds-text font-semibold shrink-0', tokens.number)}>{i + 1}</span>
          <span className={cn('text-ds-text', tokens.label)}>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default NumberedRowList;
